import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  return (
    <motion.a
      href="https://wa.me/918090773315?text=Hi%2C%20I%27m%20interested%20in%20a%20free%20TallyPrime%20demo."
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      initial={{ opacity: 0, scale: 0.8, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.96 }}
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2 rounded-full bg-[#25D366] text-white px-4 py-3.5 shadow-[0_20px_50px_rgba(37,211,102,0.5)] hover:shadow-[0_25px_60px_rgba(37,211,102,0.65)] transition-shadow group"
      aria-label="Chat on WhatsApp"
    >
      <span className="relative flex items-center justify-center w-7 h-7">
        <span className="absolute inset-0 rounded-full bg-white/25 animate-ping" />
        <MessageCircle className="w-6 h-6 relative" strokeWidth={2} />
      </span>
      <span className="hidden sm:inline font-semibold text-sm pr-1">Chat with us</span>
    </motion.a>
  );
}
